module.exports = __webpack_public_path__ + "img/logo.4fd9f748.png";